import { __decorate, __metadata } from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
let ProcessingRun = class ProcessingRun {
    constructor() {
        this.guid = null;
        this.id = null;
    }
    static equals(a, b) {
        if (a == null || b == null) {
            return false;
        }
        return a.guid == b.guid && a.id == b.id;
    }
};
__decorate([
    JsonProperty("guid", String, false),
    __metadata("design:type", String)
], ProcessingRun.prototype, "guid", void 0);
__decorate([
    JsonProperty("id", String, false),
    __metadata("design:type", String)
], ProcessingRun.prototype, "id", void 0);
ProcessingRun = __decorate([
    JsonObject("ProcessingRun")
], ProcessingRun);
export { ProcessingRun };
